<template>
  <v-form @submit.prevent="getActionMethod">
    <v-container>
      <v-row align="center" justify="center">
        <span class="red--text font-weight-bold">{{
          formValidator.getError("non_field_errors")
        }}</span>
        <v-col md="6" cols="12">
          <v-text-field
            label="Name"
            v-model="formValues.name"
            :error-messages="formValidator.getError('name')"
          ></v-text-field>
          <v-textarea
            label="Description"
            v-model="formValues.description"
            :error-messages="formValidator.getError('description')"
          ></v-textarea>
          <v-text-field
            label="Order"
            v-model="formValues.order"
            type="number"
            :error-messages="formValidator.getError('order')"
          ></v-text-field>
          <h5>Direct Communication</h5>
          <v-switch
            v-model="formValues.direct_communication"
            :label="
              `Does this communication medium involves in face to face communication?`
            "
            color="green"
          >
          </v-switch>
          <v-row>
            <v-col
              v-for="(icon, index) in mediumIconsWithName"
              :key="`commIcons-${index}`"
              cols="2"
              md="1"
            >
              <v-btn-toggle v-model="formValues.icon">
                <v-btn :value="`${icon.icon_name}`" text
                  ><v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">{{ icon.icon }}</v-icon>
                    </template>
                    {{ icon.name }}
                  </v-tooltip>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <labels-form
            class="mt-4"
            :communication_medium="formValues.id"
            v-if="formValues.id"
          ></labels-form>
        </v-col>
        <v-col cols="12"> </v-col>
        <v-col md="6" cols="12">
          <v-divider class="my-2"></v-divider>
          <v-btn
            :disabled="Object.keys(formValidator.errors).length > 0"
            class="primary"
            type="submit"
          >
            Save
          </v-btn>
          <v-btn type="reset">
            Reset
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import LabelsForm from "@/components/crm/client/forms/LabelsForm.vue";
import {
  mdiPhone,
  mdiEmail,
  mdiChat,
  mdiMessageVideo,
  mdiWhatsapp,
  mdiPhoneInTalkOutline,
  mdiSkype,
  mdiMessageProcessing,
  mdiAccountGroup,
  mdiChatProcessing
} from "@mdi/js";

export default {
  props: {
    actionData: {
      type: Object,
      required: false,
      default() {
        return {
          name: "",
          description: "",
          icon: "call",
          direct_communication: false
        };
      }
    },
    mediumIcons: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formValues: {
        ...this.actionData,
        organization: this.$store.state.shell.currentOrganizationId
      },
      mediumIconsWithName: [
        {
          icon: mdiPhone,
          icon_name: "mdiPhone",
          name: "Phone"
        },
        {
          icon: mdiEmail,
          icon_name: "mdiEmail",
          name: "Email"
        },
        {
          icon: mdiChat,
          icon_name: "mdiChat",
          name: "Chat"
        },
        {
          icon: mdiMessageVideo,
          icon_name: "mdiMessageVideo",
          name: "Video"
        },
        {
          icon: mdiWhatsapp,
          icon_name: "mdiWhatsapp",
          name: "Whatsapp"
        },
        {
          icon: mdiPhoneInTalkOutline,
          icon_name: "mdiPhoneInTalkOutline",
          name: "Viber"
        },
        {
          icon: mdiSkype,
          icon_name: "mdiSkype",
          name: "Skype"
        },
        {
          icon: mdiChatProcessing,
          icon_name: "mdiChatProcessing",
          name: "Imo"
        },
        {
          icon: mdiAccountGroup,
          icon_name: "mdiAccountGroup",
          name: "Meeting"
        },
        {
          icon: mdiMessageProcessing,
          icon_name: "mdiMessageProcessing",
          name: "SMS"
        }
      ],
      formValidator: new FormValidator()
    };
  },
  components: {
    LabelsForm
  },
  watch: {
    formValues: {
      handler() {
        this.formValidator.setError({});
      },
      deep: true
    }
  },
  methods: {
    getActionMethod() {
      if (this.formValues.id) return this.updateCommunicationMedium();
      return this.createCommunicationMedium();
    },
    createCommunicationMedium() {
      const communicationMediumAPI = "/api/v1/crm/communication-mediums/";
      this.$axios
        .$post(communicationMediumAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: "Successfully created communication medium!"
          });

          this.$emit("communicationMediumResponse", "created");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    updateCommunicationMedium() {
      const communicationMediumAPI =
        "/api/v1/crm/communication-mediums/" + this.formValues.id + "/";
      this.$axios
        .$patch(communicationMediumAPI, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: "Successfully updated communication medium!"
          });
          this.$emit("communicationMediumResponse", "updated");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
